<template>
  <article class="order_page home">
    <header class="pages_title">
      <div class="myHeader flexContainer">
        <div class="myHeaderL" @click="$router.go(-1);">
          <i class="iconfont_new icon-Left"></i>
        </div>
        <div class="myHeader textalignM">确认订单</div>
        <div class="myHeaderR textalignR"></div>
      </div>
    </header>

    <section class="pages_content order_container comfirm">
      <div class="hangbanBox">
        <div class="hangbanItem">
          <div v-if="GetType!=3">
            <div class="flexContainer difangInput">
              <div class="color1 fontSize35">
                <i class="iconfont_new icon-rili" style="font-size:0.5rem;"></i>
                日期时间：
              </div>
              <div
                class="flexItem1 textalignR color1 fontSize35"
                v-if="GetType==1"
              >{{ selectedFrequency.SetDate }} {{ selectedFrequency.time }}</div>
              <div
                class="flexItem1 textalignR color1 fontSize35"
                v-if="GetType==2"
              >{{ setDate }}起,30天内有效</div>
            </div>
            <p class="searchTip2">
              <i class="iconfont_new icon-ziyuan" style="margin-top:0;"></i>
              预定返程为套票，30天内兑换有效，在我的订单确认返程
            </p>
          </div>

          <div v-if="GetType==3">
            <div class="flexContainer difangInput">
              <div class="color1 fontSize35">
                <i class="iconfont_new icon-rili" style="font-size:0.5rem;"></i>
                去程日期时间：
              </div>
              <div
                class="flexItem1 textalignR color1 fontSize35"
              >{{ selectedFrequency.setDate }} {{ selectedFrequency.time }}</div>
            </div>
            <div class="flexContainer difangInput" v-if="GetType==3">
              <div class="color1 fontSize35">
                <i class="iconfont_new icon-rili" style="font-size:0.5rem;"></i>
                返程日期时间：
              </div>
              <div class="flexItem1 textalignR color1 fontSize35">
                <span class="miaoshaText">预定</span>
                {{ setDate }}起,30天内有效
              </div>
            </div>
            <p class="searchTip2">
              <i class="iconfont_new icon-ziyuan" style="margin-top:0;"></i>
              预定返程为套票，30天内兑换有效，在我的订单确认返程
            </p>
          </div>

          <div class="flexContainer difangInput">
            <div class="color1 fontSize35">
              <i class="iconfont_new icon-dingwei2" style="font-size:0.5rem;"></i>
              线路：
            </div>
            <div
              class="flexItem1 textalignR color1 fontSize35"
              v-if="GetType==1"
            >{{ getOn }} → {{ getOff }}</div>
            <div
              class="flexItem1 textalignR color1 fontSize35"
              v-if="GetType==2"
            >{{ getOff }} → {{ getOn }}</div>
            <div
              class="flexItem1 textalignR color1 fontSize35"
              v-if="GetType==3"
            >{{ selectedFrequency.LineName }}</div>
          </div>
          <div class="flexContainer" style="border-top:1px dashed #eaeaea;margin-top: 0.2rem;">
            <div class="flexItem3 flight-info-wrap marginT0"></div>
            <div class="flexItem1 textalignR">
              <div class="flight-number marginT0">
                <dfn>¥</dfn>
                <strong>{{ ticketPrice }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ticket_information_wrap" v-if="GetType!=2">
        <div class="table table_order_info">
          <ul class="tr flex_wrap" v-if="orderType != 2">
            <li class="td bg_tr br_tr white_text">接送服务</li>
            <li class="td flexgrow">接送最低只要15元起,一人都接！</li>
          </ul>
          <template v-if="orderType == 2">
            <ul class="tr flex_wrap">
              <li class="td bg_tr white_text">全城接送一口价</li>
              <li
                class="colorprimary"
                @click.stop="choosePickupPriceType(false)"
                style="padding:0 0.3rem;"
              >
                <label>
                  <i :class="!isRental ? 'iconfont icon-xuanze' : 'iconfont icon-xuanze1'"></i>
                  <!-- <input name="pickupPrice_selection" type="radio" /> -->
                  <span @click.stop="showPickupMessage">{{ carPoolPrice }}元[拼车]</span>
                </label>
              </li>
              <!-- <li
                class="colorprimary"
                style="padding:0 0.3rem;"
                @click.stop.prevent="choosePickupPriceType(true)"
                v-if="contactList.length > 1 && carPoolPrice + (contactList.length - 1) * 10 > rentalPrice && rentalPrice > 50"
              >
                <label>
                  <i :class="isRental ? 'iconfont icon-xuanze' : 'iconfont icon-xuanze1'"></i>
                  <span>{{ rentalPrice }}元[包车]</span>
                </label>
              </li> -->
            </ul>
          </template>
        </div>

        <div class="radio_wrap">
          <template v-for="(style, index, key) in buyStyleList">
            <label :key="key" :disabled="style.avable" @click.stop.prevent="changeOrderType(style)">
              <i :class="style.checked ? 'iconfont icon-xuanze' : 'iconfont icon-xuanze1'"></i>
              <input name="service_selection" type="radio" />
              <span class="fontSize35 fontWeightChang">{{ style.buyStyle }}</span>
            </label>
          </template>
        </div>
      </div>

      <template v-if="orderType == 2 && GetType!=2">
        <div class="ticket_information_wrap" @click="choosePickupAddress">
          <div class="ticket_information_content flex_wrap">
            <div class="ticket_information_righttext flex_wrap flex_direction_col a_i_start">
              <p>
                <span class="iconfont icon-location2 primary_text fontSize35 fontWeightChang">
                  接送地址：
                  <span
                    class="iconfont primary_text fontSize35 fontWeightChang"
                  >{{ DefaultAddress.District + '-' + DefaultAddress.Address }}</span>
                </span>
              </p>
              <p>
                <span class="iconfont icon-wenhao primary_text fontSize35 fontWeightChang">
                  行李件数：
                  <span
                    class="iconfont primary_text fontSize35 fontWeightChang"
                  >{{ luggageCount }}件</span>
                  <span class="red_text fontSize35 fontWeightChang">(点击修改接送地址与行李信息)</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="orderType == 1 && selectedFrequency.pickupTimeOut && GetType!=2">
        <div class="ticket_information_wrap" @click="choosePickupAddress">
          <div class="ticket_information_content flex_wrap">
            <div class="ticket_information_righttext flex_wrap flex_direction_col a_i_start">
              <span class="iconfont icon-location2 primary_text">
                <span class="iconfont primary_text fontSize35 fontWeightChang">接送地址：点击可添加选择接送地址</span>
              </span>
            </div>
          </div>
        </div>
      </template>

      <div class="personBox" style="margin-bottom:0.5rem;">
        <div class="flexContainer" style="padding:0 0 0.25rem 0;border-bottom:1px solid #eaeaea;">
          <div class="flexItem1 color1 fontSize35">
            <i class="iconfont_new icon-adduser personTelIcon"></i>
            乘车人
            <span
              style="float: right;font-size:0.35rem!important;"
              @click="showTicketTypeTips"
            >
              <i class="iconfont_new icon-xuzhixiao" style="margin-right:5px;color:#006535;"></i>
              查看车票类型说明
            </span>
          </div>
        </div>

        <div
          class="personBoxItem color1 fontSize35"
          v-for="(contact, key) in contactList"
          :key="key"
        >
          <div class="flexContainer">
            <div class="flexItem1">
              <i class="iconfont_new icon-shenfen4 personIcon"></i>
              {{ contact.RealName }} {{ contact.CardNO }}
            </div>
            <div class="textalignR">
              <i
                class="iconfont_new icon-close personCloseIcon"
                style="font-size:0.5rem!important;margin-right: 0.5rem;"
                @click="removeContact(contact, key)"
              ></i>
            </div>
          </div>

          <div
            class="flexContainer primaryColor-text"
            @click="changeTicketType(contact, key)"
            style="padding-left: 0.6rem;padding-top: 0.2rem;"
          >
            <i class="iconfont_new icon-wode2 primaryColor-text"></i>
            选择车票类型 : {{ contact.TicketType }}
            <span>
              <i class="iconfont icon-xiala primaryColor-text" style="margin-left:5px;"></i>
            </span>
          </div>

          <div class="priceDetailInfo color3">
            <div class="flexContainer">
              <div class="priceDetailInfo_t">票价</div>
              <div class="flexItem1">
                <div class="itemBorder"></div>
              </div>
              <div
                class="priceDetailInfo_p colorprimary"
              >¥{{ isFreeTicket ? 0 : contact.TicketPrice }}</div>
            </div>
            <div class="flexContainer">
              <div class="priceDetailInfo_t">站场服务费</div>
              <div class="flexItem1">
                <div class="itemBorder"></div>
              </div>
              <div class="priceDetailInfo_p colorprimary">¥{{ isFreeTicket ? 0 : contact.StationServicePrice }}</div>
            </div>
            <div class="flexContainer">
              <div class="priceDetailInfo_t">接送费</div>
              <div class="flexItem1">
                <div class="itemBorder"></div>
              </div>
              <div class="priceDetailInfo_p colorprimary">¥{{ contact.PickupPrice }}</div>
            </div>
            <div class="flexContainer">
              <div class="priceDetailInfo_t">超时段</div>
              <div class="flexItem1">
                <div class="itemBorder"></div>
              </div>
              <div class="priceDetailInfo_p colorprimary">¥{{ contact.OverTimePrice }}</div>
            </div>
            <div class="flexContainer">
              <div class="priceDetailInfo_t">超行李</div>
              <div class="flexItem1">
                <div class="itemBorder"></div>
              </div>
              <div class="priceDetailInfo_p colorprimary">¥{{ contact.OverLuggagePrice }}</div>
            </div>
          </div>
        </div>

        <div class="personButton" @click="addContact">
          <i class="iconfont_new icon-add1"></i>
          &nbsp;&nbsp;点击添加乘客
        </div>
      </div>
    </section>

    <footer>
      <div class="terms" @click="checkIsAgree">
        <i :class="isAgree ? 'iconfont icon-yigouxuan' : 'iconfont icon-weigouxuan'"></i>
        <p>
          <span class="fontWeightChang">我已阅读并同意</span>
          <span class="primaryColor-text fontWeightCu" @click.stop="showWarningTips">《中山候机楼购票须知》</span>
        </p>
      </div>

      <div class="price_payment">
        <p class="price_text">
          总价 :
          <span class="colorprimary">&yen;{{ totalPrice === 0 ? '--' : totalPrice }}</span>
          <!-- <i class="iconfont icon-xiala iconreversal"></i> -->
        </p>
        <button
          :class="!isAgree ? 'payment_btn' : 'payment_btn usable'"
          :disabled="!isAgree"
          @click="postOrder"
        >提交订单</button>
      </div>
    </footer>

    <transition name="tanchu" mode="out-in">
      <article v-show="isShowMask" class="mask_wrap" @click.self="hideMaskWrap">
        <transition name="scale_up" mode="out-in">
          <section v-if="isShowTicketType" class="mask_container_wrap">
            <div class="mask_article_wrap">
              <h3 class="article_title colorprimary">车票类型说明</h3>
              <p class="primaryColor-text p_title">成人票：</p>
              <p class="text_retract">一. 1.5米以上的旅客按成人标准购票，正价票不设优惠。</p>
              <p class="text_retract">二. 乘车证件（包括但不限于身份证、护照、港澳通行证等）</p>

              <p class="primaryColor-text p_title">儿童票：</p>
              <p class="text_retract">一. 1.2-1.5米，且年龄不满12周岁的旅客按儿童标准购票，可享受半票优惠。</p>
              <p class="text_retract">二. 乘车证件（包括但不限于身份证、护照、港澳通行证等）</p>

              <p class="primaryColor-text p_title">婴儿票：</p>
              <p
                class="text_retract"
              >一. 1.2米以下，且年龄不满12周岁的旅客按婴儿标准购票，可享受免票优惠，交通法规定：班车在载客数已满的情况下，免票儿童不得超过3名，以先到先得为标准，超出部分须补儿童票价上车（占座）</p>
              <p class="text_retract">二. 乘车证件（包括但不限于身份证、护照、港澳通行证等）</p>

              <p class="primaryColor-text p_title">员工票：</p>
              <p class="text_retract">一. 机场员工凭员工票按员工标准购票，可享受半票优惠。</p>
              <p class="text_retract">二. 乘车证件（包括但不限于身份证、护照、港澳通行证等）</p>

              <p class="primaryColor-text p_title">军人残疾：</p>
              <p class="text_retract">一. 持有军残证的旅客，购票前出示本人军产证按军残标准购票，可享受半票优惠。</p>
              <p class="text_retract">二. 乘车证件（包括但不限于身份证、护照、港澳通行证等）</p>
            </div>
          </section>
        </transition>

        <transition name="scale_up" mode="out-in">
          <section v-if="isShowWarning" class="mask_container_wrap">
            <div class="mask_article_wrap">
              <h3 class="article_title colorprimary">机场快线购票须知</h3>
              <p class="primaryColor-text p_title">一、购票</p>
              <p
                class="text_retract"
              >持一张成人票的旅客可免费携带一名1.2米以下的儿童乘车，但不提供座位。交通法规定：班车在载客数已满的情况下，免票儿童不得超过3名，以先到先得为标准，超出部分须补儿童票价上车（占座），身高1.2-1.5米儿童须购买儿童优惠票。超过1.5米儿童须购买全价票。</p>
              <p class="text_retract">
                1.
                微信购票时，请确认您输入的个人资料和联系方式正确无误，并保持电话畅通，以便我们能及时跟您联系。因您所留的资料不详或者不正确，或您所提供的电话号码长时间处于无人接听、忙音等状况而使我们不能及时联系到您，由此造成的损失，均由旅客本人负责。
              </p>
              <p class="text_retract">2. 微信购票须至少在班车发车前30分钟购买。</p>
              <p class="text_retract">3. 乘车证件包括但不限于身份证、护照、港澳通行证等。</p>
              <p class="primaryColor-text p_title">二、支付</p>
              <p class="text_retract">1. 微信上购票目前只支持微信支付平台。</p>
              <p class="text_retract">2. 购票时，您必须在订单提交后的10分钟内完成支付操作，逾时系统将自动取消订单，需重新操作。</p>
              <p class="text_retract">
                3.
                请勿重复支付订单。当您完成支付后，请查询订单状态，如系统发生订单状态错误等异常情况，请及时联系客服0760-88880777进行确认，在没有最终确定购票结果前，请勿重新支付订单，以免给您造成不必要的损失。
              </p>
              <p class="text_retract">4. 微信购票费用包含5元的服务费、微信平台开发费用及网络维护费。</p>
              <p class="primaryColor-text p_title">三、取票</p>
              <p
                class="text_retract"
              >购票成功后，请您在票面发车时间15分钟前到达中山候机楼取票窗口凭有效证件（包括但不限于身份证、护照、港澳通行证等）和订单二维码领取车票。</p>
              <p class="primaryColor-text p_title">四、退票</p>
              <div class="table">
                <ul class="tr bg_th_orderinfo">
                  <li class="th"></li>
                  <li class="th">普通旅客</li>
                  <li class="th">会员</li>
                </ul>
                <ul class="tr">
                  <li class="td">发车前2小时以(外)办理退票</li>
                  <li class="td">按票面额10%计收退票费</li>
                  <li class="td">免费</li>
                </ul>
                <ul class="tr">
                  <li class="td">发车前2小时以(内)办理退票</li>
                  <li class="td">按票面额20%计收退票费</li>
                  <li class="td">免费</li>
                </ul>
                <ul class="tr">
                  <li class="td">发车后</li>
                  <li class="td">不作退票</li>
                  <li class="td">按票面额30%计收退票费</li>
                </ul>
              </div>
              <p
                class="text_retract"
              >由于承运人责任造成班车晚点、脱班等延迟运输的，旅客可根据需要改乘其他班次或退票，免收退改费,会员详情请咨询0760-88880777。</p>
              <p class="primaryColor-text p_title">五、注意事项</p>
              <p class="text_retract">
                1.
                在购票时，请旅客务必确保购票信息的准确无误，由于旅客自身原因（包括但不限于发车班次、发车时间、联系人等信息填写错误）而导致购票错误并给旅客造成的一切损失，均由旅客个人负责。
              </p>
              <p class="text_retract">
                2.
                在线支付时，请旅客务必保管好您个人银行账号、密码、回单等资料。因旅客未保管好自己的账号和密码及回单等个人资料的原因，造成对旅客、候机楼或任何第三方的损害，旅客本人将负全部责任。
              </p>
            </div>
          </section>
        </transition>
      </article>
    </transition>
  </article>
</template>

<script>
import orderApi from "../request/orderApi";
import userApi from "../request/userApi";
import baseTool from "../utils/baseFunction";
import frequencyApi from "../request/frequencyApi";
import paymentApi from "../request/paymentApi";
import addressApi from "../request/addressApi";
import appointApi from "../request/appointApi";
import { mapState } from "vuex";
export default {
  name: "MakeTicketOrder",
  data() {
    return {
      selectedPickupPriceModel: {},
      selectedFrequency: null,
      showMore: false,
      contactList: [],
      member: [],
      orderType: 0,
      isAgree: false,
      ticketTypeArray: ["成人", "小童", "军人残疾"],
      extraServicesList: [], // 从服务器加载额外服务列表
      chooseServiceList: [], // 已选的服务列表
      buyTicketTips: false,
      luggagePrice: 10,
      totalPrice: 0,
      priceList: [],
      totalInsurance: 0,
      totalSubsidy: 0,
      totalLuggagePrice: 0,
      orderList: {},
      isShowMask: false,
      isShowTicket: false,
      isShowTicketType: false,
      isShowWarning: false,
      buyStyleList: [
        {
          orderType: 1,
          buyStyle: "常规购票",
          checked: false,
          avable: true,
        },
        {
          orderType: 2,
          buyStyle: "预约接送服务",
          checked: false,
          avable: true,
        },
      ],
      buyMode: 0,
      flightNumber: "",

      //2020-4-29
      baseCarPoolPrice: 0,
      carPoolPrice: 0,
      rentalPrice: 0,
      isRental: false,
      isAbleToRental: false,
      isOverTime: false,
      pickupMessage: "",
      servicePrice: 5,

      // 2020-7-17
      isFreeTicket: false,
      flightOrderNum: "",
      flightOrderData: null,
      flightPapersType: [
        "",
        "身份证",
        "护照",
        "",
        "港澳通行证",
        "台胞证",
        "",
        "回乡证",
        "军官证",
        "其他",
      ],
      priceData: null,

      //车票价格：
      ticketPrice:77,

      //返程价钱：
      fan:{
        VipPrice:77,
        Price:77,
        HalfTicketPrice:77,//小童
        DisabledArmymanTicketPrice:70,//军人
      }
    };
  },
  activated() {

    if (
      this.$route.params.mode != null &&
      this.$route.params.mode != undefined
    ) {
      this.buyMode = parseInt(this.$route.params.mode);
    } else {
      this.$Message.warning("购票模式不清楚！");
      this.$router.go(-1);
      return;
    }

    if (this.buyMode == 0 && this.OrderType && this.OpenId) {
      this.buyStyleList = [
        {
          orderType: 2,
          buyStyle: "去程接送服务[可取消]",
          checked: false,
          avable: true,
        },
        {
          orderType: 1,
          buyStyle: "常规购票[不接送选择]",
          checked: false,
          avable: true,
        },
      ];
      this.selectedFrequency = this.buyMode == 0 ? this.$store.state.ticket.SelectedFrequency[0] : this.$store.state.boat.SelectedFrequency[0];
	  this.selectedPickupPriceModel = this.buyMode == 0 ? this.$store.state.ticket.PickupPriceModel : this.$store.state.boat.PickupPriceModel;
      this.totalPrice = 0;
      this.totalLuggagePrice = 0;
      // this.orderType = this.OrderType;
      this.contactList = this.ContactList;

      this.chooseServiceList = [];
      this.isAgree = false;
      this.getExtraService();

      if(this.selectedFrequency){
         if (
          !this.selectedFrequency.IsPickup ||
          !this.selectedFrequency.pickupTimeOut
        ) {
          // 不可接送
          this.buyStyleList[0].avable = false;
          this.buyStyleList[1].checked = true;
        }
        if (this.orderType == 1) {
          this.buyStyleList[1].checked = true;
          this.buyStyleList[0].checked = false;
        } else if (this.orderType == 2) {
          this.buyStyleList[1].checked = false;
          this.buyStyleList[0].checked = true;
        }

        if (
          this.selectedFrequency.IsPickup &&
          this.selectedFrequency.pickupTimeOut
        ) {
          // this.defaultChoosePickup();
        }
      }



      //如果单返程，没有去程接送：
      if (this.GetType == 2) {
        this.buyStyleList.shift();
        this.ticketPrice = 154;
      }else{
        this.ticketPrice = this.selectedFrequency.PlacePriceList[0].AdultPrice;//12345678
      }
    } else {
      this.$router.go(-1);
    }

    this.ticketPrice = this.selectedFrequency.PlacePriceList[0].AdultPrice;
  },

  methods: {
    choosePickupAddress() {
      let that = this;
      this.$router.push({
        name: "ChoosePickupService",
        params: {
          frequency: that.selectedFrequency,
        },
      });
      // this.orderType = 2;
      // this.getTotalPrice();
    },
    showPriceDescription(type) {
      let ticketTitle = "车票价：";
      let pickupTitle = "接送费：";
      let stationTitle = "服务费内容包含：";
      let overTitle = "超时段：";
      let overLuggageTitle = "超行李";
      let ticketDes =
        "广州机场:成人71 儿童36 军残36\n深圳机场:成人75 儿童38 军残38\n深圳北站:成人75 儿童38 军残38\n珠海机场:成人45 儿童23 军残23";
      let pickupDes =
        "接送服务是指中山市旅游集散中心为特约合作商户的客户，提供接送车从“家门口”接送到特约合作商户的“一口价拼车”服务。\n服务特色：\n1、自营专车专司机（安全保障）;\n2、一口价（不绕路，不怕堵车，不跳价）;\n3、24小时服务，只要下单，总有一人一车为您守候；\n4、同地址同终点第一人收拼车价，每增加一人加收10元;\n5、当拼车价大于包车价后可选包车价。\n特约合作商户：中山候机楼、中山港客运码头";
      let stationDes =
        "1、站场维护费5元/人（线上平台开发及维护、站场硬件设施使用及维护等）;\n2、站场服务费5元/人（可为旅客办理已开放航班的值机、行李托运，可为旅客提供行李打包或寄存、临时外用药品服务、WIFI上网服务等）;\n3、服务费合计10元/人，微信线上购票可优惠5元/人，请向前台工作人员领取服务费发票。";
      let overtimeDes =
        "接送车正常服务时间为AM7:00至PM10:00，当服务时间超出正常服务时间时，每个市内接送单需加收10元/单的超时段服务费。";
      let overLuggageDes = "每人免费携带一件行李，超出按10元/件收取费用。";
      let title = "",
        content = "";
      if (type == 1) {
        (title = ticketTitle), (content = ticketDes);
      } else if (type == 2) {
        (title = stationTitle), (content = stationDes);
      } else if (type == 3) {
        (title = pickupTitle), (content = pickupDes);
      } else if (type == 4) {
        (title = overTitle), (content = overtimeDes);
      } else if (type == 5) {
        (title = overLuggageTitle), (content = overLuggageDes);
      }
      this.$Modal.warning({ title: title, content: content });
    },
    setStoreData(updateObj) {
      this.$store.commit(
        this.buyMode == 0
          ? "ticket/setBaseTicketCondition"
          : "boat/setBaseBoatCondition",
        updateObj
      );
    },
    showPickupMessage() {
      this.$Modal.warning({ title: "接送明细", content: this.pickupMessage });
      // this.isRental = false;
      // this.checkIsVip();
    },
    choosePickupPriceType(boolVal) {
      this.isRental = boolVal;
      this.checkIsVip();
      // this.getTotalPrice();
    },
    // 根据地址计算接送价格
    // computedPickupPrice(address) {
    //   let that = this;
    //   appointApi
    //     .convertAddressToLocation("中山市", address)
    //     .then((userSucRes) => {
    //       if (
    //         userSucRes.status == "1" &&
    //         userSucRes.info == "OK" &&
    //         userSucRes.pois &&
    //         userSucRes.pois.length > 0
    //       ) {
    //         let userLocation = userSucRes.pois[0].location;
    //         appointApi
    //           .convertAddressToLocation("中山市", "中山候机楼")
    //           .then((ourSucRes) => {
    //             if (
    //               ourSucRes.status == "1" &&
    //               ourSucRes.info == "OK" &&
    //               ourSucRes.pois &&
    //               ourSucRes.pois.length > 0
    //             ) {
    //               let ourLocation = ourSucRes.pois[0].location;
    //               let userLat = userLocation.split(",")[1],
    //                 userLng = userLocation.split(",")[0];
    //               let ourLat = ourLocation.split(",")[1],
    //                 ourLng = ourLocation.split(",")[0];

    //               that.pickupMessage = "";
    //               appointApi
    //                 .driverSearch(userLocation, ourLocation)
    //                 .then((apiResult) => {
    //                   console.log("apiResult=>", apiResult);
    //                   if (
    //                     apiResult.status == "1" &&
    //                     apiResult.info == "OK" &&
    //                     apiResult.route.paths.length > 0
    //                   ) {
    //                     let driveCarDistance =
    //                       apiResult.route.paths[0].distance;
    //                     let driverCarDuration =
    //                       apiResult.route.paths[0].duration;
    //                     let minute = Math.round(driverCarDuration / 60);
    //                     let kilos = Math.round(driveCarDistance / 1000);
    //                     let tmp = new Date(
    //                       that.selectedFrequency.SetTime.replace(
    //                         /-/g,
    //                         "/"
    //                       ).replace("T", " ")
    //                     );
    //                     let appointTime = "";
    //                     if (tmp != "Invalid Date") {
    //                       appointTime = tmp;
    //                     } else {
    //                       appointTime = new Date(
    //                         that.selectedFrequency.SetTime
    //                       );
    //                     }
    //                     console.log(tmp);

    //                     console.log(appointTime);
    //                     appointTime.setTime(
    //                       appointTime.getTime() - (minute + 10) * 60 * 1000
    //                     );
    //                     let tmpDate = baseTool.formatterDateTime(appointTime);
    //                     console.log(tmpDate);
    //                     let appointHour = that.selectedFrequency.time.replace(
    //                       ":",
    //                       ""
    //                     );
    //                     if (parseInt(appointHour) - minute - 10 < 700) {
    //                       that.isOverTime = true;
    //                     }

    //                     appointApi
    //                       .getFarePrediction2(
    //                         address,
    //                         userLng,
    //                         userLat,
    //                         "中山候机楼",
    //                         ourLng,
    //                         ourLat,
    //                         tmpDate
    //                       )
    //                       .then((fareRes) => {
    //                         if (
    //                           fareRes.success &&
    //                           fareRes.data.amounts &&
    //                           fareRes.data.amounts.length > 0
    //                         ) {
    //                           let marketPrice = Math.round(
    //                             fareRes.data.amounts[0].amount * 1.6
    //                           );
    //                           that.pickupMessage = `行程：${address}->中山候机楼\n市场价约：${marketPrice}元\n行程预估：${kilos}公里\n预估时间：${minute}分钟\n预估接送时间：${tmpDate}\n${
    //                             that.isOverTime
    //                               ? "接送时间早于AM7:00需加收10元超时段服务费"
    //                               : ""
    //                           }`;
    //                           console.log(that.pickupMessage);

    //                           let StraighDistance = baseTool.getDistance(
    //                             userLat,
    //                             userLng,
    //                             ourLat,
    //                             ourLng
    //                           );
    //                           if (StraighDistance % 1000 < 50)
    //                             StraighDistance -= 50;
    //                           let LongDistance = Math.ceil(
    //                             StraighDistance / 1000
    //                           );
    //                           if (LongDistance > 15) {
    //                             that.isAbleToRental = true;
    //                           }

    //                           that.rentalPrice = 15;
    //                           that.carPoolPrice = 15;
    //                           for (let i = 1; i <= LongDistance; i++) {
    //                             if (i > 2 && i <= 10) that.rentalPrice += 3;
    //                             if (i > 10 && i <= 20) that.rentalPrice += 4;
    //                             if (i > 20 && i <= 30) that.rentalPrice += 5;
    //                             if (i > 30) that.rentalPrice += 6;
    //                           }

    //                           if (LongDistance > 2)
    //                             that.carPoolPrice += (LongDistance - 2) * 3;

    //                           if (LongDistance < 10) {
    //                             if (that.carPoolPrice > 15) {
    //                               that.carPoolPrice = Math.ceil(
    //                                 that.carPoolPrice * 0.9
    //                               );
    //                             }
    //                           } else if (
    //                             LongDistance >= 10 &&
    //                             LongDistance < 15
    //                           ) {
    //                             that.rentalPrice =
    //                               that.rentalPrice +
    //                               Math.ceil(that.rentalPrice * 0.05);
    //                           } else if (
    //                             LongDistance >= 15 &&
    //                             LongDistance < 20
    //                           ) {
    //                             that.carPoolPrice =
    //                               that.carPoolPrice +
    //                               Math.ceil(that.carPoolPrice * 0.05);
    //                             that.rentalPrice =
    //                               that.rentalPrice +
    //                               Math.ceil(that.rentalPrice * 0.08);
    //                           } else if (
    //                             LongDistance >= 20 &&
    //                             LongDistance < 25
    //                           ) {
    //                             that.carPoolPrice =
    //                               that.carPoolPrice +
    //                               Math.ceil(that.carPoolPrice * 0.1);
    //                             that.rentalPrice =
    //                               that.rentalPrice +
    //                               Math.ceil(that.rentalPrice * 0.1);
    //                           } else if (
    //                             LongDistance >= 25 &&
    //                             LongDistance < 30
    //                           ) {
    //                             that.carPoolPrice =
    //                               that.carPoolPrice +
    //                               Math.ceil(that.carPoolPrice * 0.15);
    //                             that.rentalPrice =
    //                               that.rentalPrice +
    //                               Math.ceil(that.rentalPrice * 0.15);
    //                           } else if (LongDistance >= 30) {
    //                             that.carPoolPrice =
    //                               that.carPoolPrice +
    //                               Math.ceil(that.carPoolPrice * 0.15);
    //                             that.rentalPrice =
    //                               that.rentalPrice +
    //                               Math.ceil(that.rentalPrice * 0.2);
    //                           }

    //                           that.baseCarPoolPrice = that.carPoolPrice;

    //                           if (that.isOverTime) {
    //                             that.carPoolPrice += 10;
    //                             that.rentalPrice += 10;
    //                           }
    //                         }
    //                       });
    //                   }
    //                 });
    //             }
    //           });
    //       }
    //     });
    // },
    // defaultChoosePickup() {
    //   let that = this;
    //   addressApi.getAddressList(this.OpenId, "").then((sucRes) => {
    //     if (sucRes.success && sucRes.data && sucRes.data.length > 0) {
    //       let addressModel = null;
    //       for (let i = 0; i < sucRes.data.length; i++) {
    //         if (sucRes.data[i].IsDefault) {
    //           addressModel = sucRes.data[i];
    //           this.setStoreData({ DefaultAddress: addressModel });
    //           break;
    //         }
    //       }

    //       // that.computedPickupPrice(addressModel.Address);

    //       frequencyApi.getPickupAreaPriceList().then((sucRes2) => {
    //         if (sucRes2.success && sucRes2.data && sucRes2.data.length > 0) {
    //           let districtPriceModel = null;
    //           for (let i = 0; i < sucRes2.data.length; i++) {
    //             if (
    //               sucRes2.data[i].District === addressModel.District &&
    //               sucRes2.data[i].Status
    //             ) {
    //               districtPriceModel = sucRes2.data[i];
    //               that.buyStyleList[1]["checked"] = false;
    //               that.buyStyleList[0]["checked"] = true;
    //               // that.setStoreData({ DefaultAddress: districtPriceModel });
    //               that.orderType = 2;
    //               that.selectedDistrictModel = districtPriceModel;
    //               // that.district = addressModel.District;
    //               // that.contact = addressModel.Contact;
    //               // that.mobile = addressModel.Mobile;
    //               // that.luggageCount = 0;
    //               break;
    //             }
    //           }
    //         }
    //       });
    //     }
    //   });
    //   // this.getTotalPrice();
    // },
    getTotalPrice() {
      let that = this;
      console.log(this.DefaultAddress);
	  console.log('orderType',this.orderType);
      orderApi
        .getTicketTotalPrice(
          this.orderType,
          this.selectedFrequency.ID,
          // (this.DefaultAddress && this.DefaultAddress.District) ? this.DefaultAddress.District : '',
          this.orderType == 2 ? this.DefaultAddress.District:'',
          this.luggageCount,
          this.orderType == 2 ? this.DefaultAddress.Address:'',
          this.isRental,
          this.contactList,
          this.isFreeTicket,
          this.selectedFrequency.PlacePriceList[0].GetOnStation,
          this.selectedFrequency.PlacePriceList[0].GetOffStation,
        )
        .then((sucRes) => {
          if (sucRes.success) {
            this.totalPrice = sucRes.data.TotalPrice;
            this.priceData = sucRes.data;
            this.member = sucRes.data.ContactList;
            this.contactList = this.member
            if(sucRes.data.pickupObj != null){
              this.carPoolPrice = sucRes.data.pickupObj.carPoolPrice
            }
            console.log('this.member',this.member);
            console.log('this.priceData',this.priceData);
            console.log('this.contactList',this.contactList);

          }
        });
    },
    //2019-5-14 23:10
    changeOrderType(item) {
      let that = this;
      if (item.orderType == 2 && !item.avable) {
        this.$Message.warning(
          "当前班次线路不支持接送服务，请选择带有接送标识的线路。"
        );
        return;
      }
      if (item.orderType == 1) {
        this.buyStyleList[1].checked = true;
        this.buyStyleList[0].checked = false;
        this.orderType = 1;
        if (that.contactList.length > 0) {
          // this.checkIsVip();
          this.getTotalPrice();
        }
      } else if (item.orderType == 2) {
        this.buyStyleList[1].checked = false;
        this.buyStyleList[0].checked = true;
        this.orderType = 2;
        this.choosePickupAddress();
        // if (that.contactList.length > 0) {
        //   // this.getTotalPrice();
        // }
      }

    },
    showMoreInfo() {
      this.showMore = !this.showMore;
    },
    getExtraService() {
      let that = this;
      this.$Spin.show();
      frequencyApi
        .getExtraServiceList(this.buyMode == 0 ? 1 : 2, this.setDate, 0)
        .then((sucRes) => {
          if (sucRes.success && sucRes.data.length > 0) {
            that.extraServicesList = sucRes.data;
          }
          that.setContactListInfo();
        });
        // this.getTotalPrice();
    },
    setContactListInfo() {
      let that = this;
      for (let i = 0; i < this.contactList.length; i++) {
        this.contactList[i]["TicketType"] = "成人";
        this.contactList[i]["ExtraService"] = [];
        let j = 0;
        this.extraServicesList.forEach((server) => {
          if (
            server.ServiceName == "机场VIP休息室(登机口)" &&
            that.selectedFrequency.ModelID != 7
          ) {
          } else {
            let tmp = Object.assign({}, server);
            if (server.IsSingle) {
              if (server.GroupName == "") {
                that.contactList[i].ExtraService.push(tmp);
                that.contactList[i].ExtraService[j]["IsChoose"] = false;
                that.contactList[i].ExtraService[j]["BelongsTo"] =
                  that.contactList[i].RealName;
                ++j;
              } else {
                let has = false;
                that.contactList[i].ExtraService.forEach((tmpServer) => {
                  if (tmpServer.GroupName == server.GroupName) has = true;
                });
                if (!has) {
                  that.contactList[i].ExtraService.push(tmp);
                }
              }
            }
          }
        });
      }
      this.checkIsVip();
      // this.getTotalPrice();
    },
    addContact() {
      this.setStoreData({ ContactList: [] });

      this.contactList = [];
      this.$router.push({
        name: "MyContactManager",
        params: {
          mode: "choose",
        },
      });
      // this.getTotalPrice();
    },
    removeContact(contact, index) {
      let tmpArray = this.contactList.concat();
      tmpArray.splice(index, 1);
      this.contactList = tmpArray;
      // this.contactList.splice(index, 1);
      this.setStoreData({ ContactList: this.contactList });
      // this.computedInfo();
      if (this.contactList.length > 0) this.getTotalPrice();
      else this.totalPrice = 0;
    },
    showBuyTicketTips() {
      this.buyTicketTips = !this.buyTicketTips;
    },
    checkIsAgree() {
      if (this.contactList.length > 0) {
        this.isAgree = !this.isAgree;
      } else {
        this.$Message.warning("请先选择乘车人！");
      }
    },
    checkIsVip() {
      let that = this;
      if (this.contactList.length > 0) {
        this.$Spin.show();
        this.checkVipOneByOne(0);
      } else {
        that.$Spin.hide();
      }
    },
    checkVipOneByOne(index) {
      let that = this;
      if (index < this.contactList.length) {
        let contact = this.contactList[index];
        let realname = contact.RealName;
        let CardNO = contact.CardNO;
        let sendData = {
          name: realname,
          idcard: CardNO,
        };
        // this.getTotalPrice();
        userApi.checkIsVip(realname, CardNO).then((sucRes) => {
          if (sucRes.success) contact.IsVip = sucRes.data;
          else contact.IsVip = false;
          that.contactList[index] = contact;
          this.getTotalPrice();
          if (index + 1 == that.contactList.length) {
            that.$Spin.hide();
            // that.computedPersonTicketPrice();
          } else {
            that.checkVipOneByOne(++index);
          }
        });
      }
    },
    postOrder() {
      let that = this;
      var phoneConfim = true;
      if(this.orderType == 0){
        this.$Message.warning('请先选择‘常规购票’或‘接送服务’');
        return;
      }
      if (this.orderList.ID > 0) {
        this.payRequest();
      } else {
        this.chooseServiceList = [];
        this.contactList.forEach((member) => {
          if(member.Mobile == ''){
            // alert('乘客手机号码不得为空');
            phoneConfim = false;
          }
          member.ExtraService.forEach((service) => {
            if (service.IsChoose) {
              service["RealName"] = member.RealName;
              that.chooseServiceList.push(service);
            }
          });
        });
        if(phoneConfim == false){
          alert('乘客手机号码不得为空');
          return;
        }
        this.$Spin.show();
        let tmpFreArr = [];
        tmpFreArr.push(this.selectedFrequency);
        console.log(tmpFreArr)
        if (this.orderType == 1) {
          // 一般购票下单
          orderApi
            .createTicketOrderV2(
              this.OpenId,
              this.orderType,
              this.getOn,
              this.getOff,
              tmpFreArr,
              this.contactList,
              this.orderType == 2 ? this.DefaultAddress.District:'',
              this.orderType == 2 ? this.DefaultAddress.Address:'',
              this.contactList[0].Mobile,
              '',
              this.luggageCount,
              false,
              false,
              '',
              this.$store.state.user.Location,
              this.flightNumber,
              this.flightOrderNum,
              '',
            )
            .then((sucRes) => {
              if (sucRes.success) {
                that.orderList = sucRes.data;
                that.$Message.success(sucRes.message);
                that.payRequest(that.orderList.ID);
              } else {
                this.$Message.warning(sucRes.message);
              }
              that.$Spin.hide();
            });
        } else if (this.orderType == 2 || this.orderType == 3) {
          orderApi
            .createTicketOrderV2(
              this.OpenId,
              this.orderType,
              this.getOn,
              this.getOff,
              tmpFreArr,
              this.contactList,
              this.orderType == 2 ? this.DefaultAddress.District:'',
              this.orderType == 2 ? this.DefaultAddress.Address:'',
              this.contactList[0].Mobile,
              '',
              this.luggageCount,
              false,
              false,
              '',
              this.$store.state.user.Location,
              this.flightNumber,
              this.flightOrderNum,
              '',
            )
            .then((sucRes) => {
              if (sucRes.success) {
                this.setStoreData({ ContactList: [], PickupPriceModel: null });
                this.$store.commit(
                  this.buyMode == 0
                    ? "ticket/setPickupPriceModel"
                    : "boat/setPickupPriceModel",
                  null
                );
                that.orderList = sucRes.data;
                that.$Message.success(sucRes.message);
                that.payRequest();
              } else {
                that.$Message.warning(sucRes.message);
              }
              that.$Spin.hide();
            });
          // 接送车下单
        }
      }
    },
    payRequest() {
      let that = this;
      paymentApi
        .getWeChatPayParams(
          this.$store.state.user.OpenId,
          this.orderList.ID,
          2,
          0
        )
        .then((sucRes) => {
          if (sucRes.success) {
            wx.chooseWXPay({
              timestamp: sucRes.data.timeStamp,
              nonceStr: sucRes.data.nonceStr,
              package: sucRes.data.package,
              signType: sucRes.data.signType,
              paySign: sucRes.data.paySign,
              success: (res) => {
                this.$Message.success("支付成功！");
                this.orderList = {};
                this.$store.commit("ticket/clearData");
                this.$store.commit("boat/clearData");

                this.$route.replace({
                  name: "MainIndexPage",
                  params: {
                    page: "myorder",
                  },
                });
              },
              fail: (fail) => {
                this.$Message.warning("支付失败！");
                // this.getOrderList();
              },
            });
          }
        });
    },
    showSingleService(contact, index, service, idx) {},
    hideMaskWrap() {
      this.isShowMask = false;
      this.isShowTicketType = false;
      this.isShowWarning = false;
    },
    showTicketTypeTips() {
      this.isShowMask = true;
      this.isShowTicketType = true;
      this.isShowWarning = false;
    },
    showWarningTips() {
      this.isShowMask = true;
      this.isShowTicketType = false;
      this.isShowWarning = true;
    },
    changeTicketType(contact, index) {
      let that = this;
      let tmpArray = [];
      for (let i = 0; i < this.ticketTypeArray.length; i++) {
        let tmp = {
          label: this.ticketTypeArray[i],
          value: this.ticketTypeArray[i],
        };
        tmpArray.push(tmp);
      }
      this.$weui.picker(tmpArray, {
        onConfirm(result) {
          // console.log('result[0].value',result[0].value)
          // console.log('contact.TicketType',contact.TicketType)
          // console.log('this.contactList',that.contactList)
          // contact.TicketType = result[0].value;
          that.contactList[index].TicketType = result[0].value;
          // that.computedPersonTicketPrice();
          that.getTotalPrice();
        },
      });
    },
    // computedPersonTicketPrice() {
    //   let that = this;
    //   //			console.log(this.contactList);
    //   for (let i = 0; i < this.contactList.length; i++) {
    //     let contact = this.contactList[i];
    //     let isVip = contact.IsVip;
    //     let totalPrice = 0,
    //       ticketPrice = 0,
    //       stationServicePrice = 5,
    //       overTimePrice = 0,
    //       pickupPrice = 0;

    //     let set = "";
    //     switch (contact.TicketType) {
    //       case "成人":
    //         if (isVip) totalPrice += this.selectedFrequency ? this.selectedFrequency.VipPrice:this.fan.VipPrice;
    //         else totalPrice += this.selectedFrequency ?this.selectedFrequency.Price:this.fan.Price;
    //         break;
    //       case "小童":
    //         totalPrice += this.selectedFrequency ?this.selectedFrequency.HalfTicketPrice:this.fan.HalfTicketPrice;
    //         break;
    //       case "婴儿":
    //         totalPrice += 0;
    //         break;
    //       case "军人残疾":
    //         totalPrice += this.selectedFrequency ?this.selectedFrequency.DisabledArmymanTicketPrice:this.fan.DisabledArmymanTicketPrice;
    //         break;
    //     }
    //     ticketPrice = totalPrice - 5;
    //     // 计算个人额外服务收费
    //     contact.ExtraService.forEach((val) => {
    //       if (val.IsChoose) {
    //         totalPrice += isVip ? val.VipPrice : val.Price;
    //       }
    //     });

    //     if (this.orderType == 2) {
    //       if (i == 0) {
    //         if (!this.isRental) {
    //           pickupPrice = that.baseCarPoolPrice;
    //           if (this.isOverTime) overTimePrice = 10;
    //         } else {
    //           pickupPrice = that.rentalPrice;
    //         }
    //       } else {
    //         if (!this.isRental) {
    //           pickupPrice = 10;
    //         }
    //       }
    //     }

    //     let overLuggagePrice = 0;
    //     if (this.luggageCount > this.contactList.length) {
    //       overLuggagePrice = (this.luggageCount - this.contactList.length) * 10;
    //     }
    //     if (i == 0) {
    //       this.contactList[i].OverLuggagePrice = overLuggagePrice;
    //     } else {
    //       this.contactList[i].OverLuggagePrice = 0;
    //     }
    //     this.contactList[i].TicketPrice = ticketPrice;
    //     this.contactList[i].PickupPrice = pickupPrice;
    //     this.contactList[i].OverTimePrice = overTimePrice;

    //     this.contactList[i].computedPrice =
    //       this.orderType == 2 || this.orderType == 3
    //         ? set + totalPrice
    //         : totalPrice;
    //   }
    //   // this.computedInfo();
    //   this.getTotalPrice();
    // },
    // computedInfo() {
    //   let that = this;
    //   (this.totalPrice = 0),
    //     (this.totalInsurance = 0),
    //     (this.totalSubsidy = 0),
    //     (this.totalLuggagePrice = 0);
    //   let adult = 0,
    //     child = 0,
    //     baby = 0,
    //     disableAr = 0,
    //     notickCount = 0;
    //   for (let j = 0; j < this.contactList.length; j++) {
    //     // 循环计算各票类人数
    //     if (this.contactList[j].TicketType == "成人") {
    //       (adult += 1), (notickCount += 1);
    //     } else if (this.contactList[j].TicketType == "小童") {
    //       child += 1;
    //     } else if (this.contactList[j].TicketType == "婴儿") {
    //       baby += 1;
    //     } else if (this.contactList[j].TicketType == "军人残疾") {
    //       (disableAr += 1), (notickCount += 1);
    //     }
    //   }
    //   this.priceList = [];

    //   if (adult > 0) {
    //     this.priceList.push({
    //       text:
    //         this.selectedFrequency.TypeName +
    //         "成人票:" +
    //         this.selectedFrequency.Price +
    //         "*" +
    //         adult,
    //       value: this.selectedFrequency.Price * adult,
    //     });
    //     this.totalPrice += this.selectedFrequency.Price * adult;
    //   }
    //   if (disableAr > 0) {
    //     this.priceList.push({
    //       text:
    //         this.selectedFrequency.TypeName +
    //         "军人残疾票:" +
    //         this.selectedFrequency.DisabledArmymanTicketPrice +
    //         "*" +
    //         disableAr,
    //       value: this.selectedFrequency.DisabledArmymanTicketPrice * disableAr,
    //     });
    //     this.totalPrice +=
    //       this.selectedFrequency.DisabledArmymanTicketPrice * disableAr;
    //   }
    //   if (child > 0) {
    //     this.priceList.push({
    //       text:
    //         this.selectedFrequency.TypeName +
    //         "小童票:" +
    //         this.selectedFrequency.HalfTicketPrice +
    //         "*" +
    //         child,
    //       value: this.selectedFrequency.HalfTicketPrice * child,
    //     });
    //     this.totalPrice += this.selectedFrequency.HalfTicketPrice * child;
    //   }
    //   if (baby > 0) {
    //     let text = this.selectedFrequency.TypeName + "婴儿票：";
    //     let value = 0;
    //     if (baby <= notickCount) {
    //       value = 0 * baby;
    //       text += "0*" + baby;
    //     } else {
    //       let more = baby - notickCount;
    //       if (this.selectedFrequency.TypeID == 2) {
    //         text += "0*" + baby;
    //         value = 0;
    //       } else {
    //         text +=
    //           "0*" +
    //           notickCount +
    //           "+" +
    //           this.selectedFrequency.HalfTicketPrice +
    //           "*" +
    //           more;
    //         value =
    //           0 * notickCount + this.selectedFrequency.HalfTicketPrice * more;
    //       }
    //     }
    //     this.totalPrice += value;
    //     this.priceList.push({
    //       text: text,
    //       value: value,
    //     });
    //   }

    //   if (this.orderType == 2 || this.orderType == 3) {
    //     // 另外计算接送车价格
    //     let vipCount = 0;
    //     for (let i = 0; i < this.contactList.length; i++) {
    //       if (this.contactList[i].IsVip) ++vipCount;
    //     }
    //     let totalMember = adult + disableAr + child;
    //     let text =
    //       "非会员定点接送服务费：" +
    //       this.selectedPickupPriceModel.Price +
    //       "*" +
    //       (totalMember - vipCount);
    //     let value =
    //       this.selectedPickupPriceModel.Price * (totalMember - vipCount);
    //     this.totalPrice +=
    //       this.selectedPickupPriceModel.Price * (totalMember - vipCount);
    //     this.priceList.push({
    //       text: text,
    //       value: value,
    //     });
    //     let vipTmp = {
    //       text:
    //         "会员定点预约接送服务费：" +
    //         this.selectedPickupPriceModel.VipPrice +
    //         "*" +
    //         vipCount,
    //       value: this.selectedPickupPriceModel.VipPrice * vipCount,
    //     };
    //     this.totalPrice += this.selectedPickupPriceModel.VipPrice * vipCount;
    //     this.priceList.push(vipTmp);

    //     // 2018.11.11 计算增加的行李费用
    //     if (
    //       this.luggageCount > 0 &&
    //       this.luggageCount > totalMember + vipCount
    //     ) {
    //       let moreLuggageCount = this.luggageCount - (totalMember + vipCount);
    //       this.totalLuggagePrice = moreLuggageCount * this.luggagePrice;
    //       this.totalPrice += this.totalLuggagePrice;
    //     }

    //     //2018.12.13  订单内大于2人则立减10元
    //     if (totalMember >= 2) {
    //       this.totalPrice -= 10;
    //     }
    //   }
    //   //2018-12-24 计算额外服务费用
    //   this.contactList.forEach((person) => {
    //     person.ExtraService.forEach((service) => {
    //       if (service.IsChoose) {
    //         that.totalPrice += person.IsVip ? service.VipPrice : service.Price;
    //       }
    //     });
    //   });
    // },
  },
  computed: mapState({
    DefaultAddress: (state) =>
      this.buyMode == 0
        ? state.ticket.DefaultAddress
        : state.boat.DefaultAddress,
    OpenId: (state) => state.user.OpenId,

    OrderType: (state) => state.ticket.OrderType,
    getOn: (state) => state.ticket.GetOn,
    getOff: (state) => state.ticket.GetOff,
    GetType: (state) => state.ticket.GetType,
    setDate: (state) =>state.ticket.SetDate,
    setTime: (state) =>state.ticket.SetTime,
    // selectedFrequency: state => (this.buyMode == 0 ? state.ticket.SelectedFrequency[0] : state.boat.SelectedFrequency[0]),
    luggageCount: (state) =>
      this.buyMode == 0 ? state.ticket.LuggageCount : state.boat.LuggageCount,
    ContactList: (state) =>
      this.buyMode == 0 ? state.ticket.ContactList : state.boat.ContactList,
  }),
};
</script>

<style lang="less" scoped>
@import "../style/public";
@import "../style/home.less";
.pages_title {
  background-color: transparent;
  padding: 0;
  color: #fff;
  border-bottom: none;
}
.ticket_information_wrap {
  background-color: #f8f8f8;
  // .border-B;
  font-size: 0.35rem;
  flex-wrap: wrap;
  // .blockPadding();
  padding: 0 0.2rem 0.2rem;
}
.ticket_information_lefticon {
  padding: 2% 0;
}
.ticket_information_lefticon {
  flex: 0 0 10%;
  line-height: 1.8em;
  text-align: right;
}
.ticket_information_wrap .iconfont {
  font-size: 0.4rem;
  margin: 0 5px;
}
.ticket_information_righttext {
  flex: 1;
}
.ticket_information_righttext > p {
  line-height: 1.8em;
}
.ticket_information_detail {
  flex: 100%;
  line-height: 1.8em;
  border-top: 1px solid #666;
  overflow: auto;
  transition: all 0.3s;
  padding: 2% 0;
  height: 15vh;
}
.ticket_information_detail > p {
  padding: 0 5%;
}
.ticket_information_detail > p {
  color: #888;
}
.ticket_information_detail > p > span {
  color: #333;
  margin-left: 2%;
}
.moreinfo > .iconfont {
  font-size: 0.35rem;
  line-height: 1.8em;
}

.radio_wrap {
  width: 100%;
  margin: 0 auto 0px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  .flex_wrap(initial, center);
  background: #ffffff;
}
.radio_wrap label {
  flex: 1;
  position: relative;
  text-align: center;
  padding: 5px;
}
.radio_wrap label .iconfont {
  margin: 0;
  color: #04be02;
  font-size: 0.4rem;
}
.radio_wrap label:first-child {
  border-right: 1px solid #eaeaea;
}
.select_passenger {
  padding-left: 3%;
  font-size: 0.35rem;
  line-height: 6vh;
  border-bottom: 1px solid #888;
  .flex_wrap(space-between);
}
.select_passenger .iconfont {
  margin-left: 0;
  margin-right: 10px;
}
.passengerinfo_select {
  font-size: 0.35rem;
}
.passengerinfo_list {
  // margin-top: 3%;
  border: solid #888888;
  border-width: 1px 0;
  background-color: #f8f8f8;
  .flex_wrap(space-between, center);
}
.passengerinfo_list_left {
  flex: 0 0 70%;
  padding: 2% 5%;
}
.passengerinfo_list_left p {
  font-size: 0.35rem;
}
.passengerinfo_list_right {
  flex: 1;
  align-self: stretch;
  .flex_wrap(center, center);
  .icon-shanchu1 {
    margin: 0 10px;
  }
  /*padding: 2% 5%;*/
}
.passengerinfo_list_right > span {
  color: #888;
  border: 1px solid #888;
  padding-right: 10px;
  line-height: 1.8em;
}
.passengerinfo_list_right > span:active {
  background-color: #ddd;
  color: #aaa;
}

/*update_service--s*/
.update_service {
  width: 100%;
  line-height: 4vh;
  margin: 5px 0;
  flex-wrap: wrap;
}
.update_service .iconfont {
  margin: 0 5px 0 0;
  font-size: 0.38rem;
}
.update_service_title {
  flex: 0 0 100%;
  color: #e22222;
  line-height: 4vh;
  border: dashed #888;
  border-width: 1px 0;
  margin-bottom: 5px;
}
.update_service_item {
  display: flex;
  align-items: center;
}
.update_service_item .site_name_w {
  width: 12em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
}

/*update_service--e*/

/*foot*/
.order_foot {
  /*position: fixed;
  	bottom: 0;*/
}
.terms {
  background: #6f6f6f;
  color: #fff;
  font-size: 0.38rem;
  line-height: 8vh;
  .flex_wrap(initial, center);
}
.terms > p {
  font-size: 0.4rem;
}
.terms > .iconfont {
  width: 35px;
  align-self: stretch;
  text-align: center;
  font-size: 0.5rem;
  padding-top: 2px;
  margin: 0;
}

/*计价明细*/
.price_detail {
  height: 12vh;
  transition: all 0.3s;
  overflow: auto;
}
.price_detail_title > h6 {
  background-color: #006535;
  color: #ffffff;
  text-align: center;
  line-height: 4vh;
  font-size: 0.4rem;
  text-indent: 2px;
  letter-spacing: 2px;
}
.bus_ticket_detail > span {
  padding: 0 3%;
  font-size: 0.35rem;
  color: #333;
  line-height: 4vh;
}
/*支付*/

.price_payment {
  border-top: 1px solid #888;
  .flex_wrap;
}
.price_payment > .price_text,
.price_payment > .payment_btn {
  flex: 0 0 50%;
}
.price_text,
.payment_btn {
  line-height: 1.2rem;
  text-align: center;
  font-size: 0.45rem;
}
.price_text > span {
  font-weight: 600;
  transition: all 0.3s;
}
.payment_btn {
  border: none;
  color: #888;
  background-color: #ddd;
}
/* 191011 */
.radio_wrap {
  width: 100%;
  margin: 0 auto 0px;
  align-items: center;
  border: 1px solid #ffffff;
  border-radius: 5px;
}
.radio_wrap label {
  flex: 1;
  position: relative;
  text-align: center;
  padding: 5px;
}
.radio_wrap label .iconfont {
  margin: 0;
  color: #04be02;
  font-size: 0.4rem;
}
.radio_wrap label:first-child {
  border-right: 1px solid #eaeaea;
}
.terms > .iconfont.icon-yigouxuan {
  color: #006535;
}
/* 191011 */
.usable {
  background-color: #006535;
  color: #fff;
}
.payment_btn.usable:active {
  background-color: #006535;
  color: #fff;
}
.ticket_information_content {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 0.3rem;
  border-radius: 0.15rem;
  background-color: #ffffff;
  cursor: pointer;
}
.table_order_info {
  width: 100% !important;
  border: none !important;
  background: #ffffff !important;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 0.15rem;
}
.table_order_info .th[data-v-1c9934d4]:nth-last-child(n + 2),
.table_order_info .td[data-v-1c9934d4]:nth-last-child(n + 2) {
  border-right: 1px solid #eaeaea !important;
}
.table_order_info .bg_tr {
  background: #fff4d6 !important;
  color: rgb(255, 153, 0) !important;
}
.table_order_info .tr[data-v-1c9934d4]:nth-last-child(n + 2) {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/MakeTicketOrder.vue